<script>
  import { urlServeur } from "../components/conf.js";
  import Spinner from "../components/ToolsSpinner.svelte";

  let promise;

  const fetchData = async () => {
    const response = await fetch(urlServeur + "/api_employe/sal_par_poste");
    if (response.ok) {
      const res = await response.json();
      // console.log(res.payload);
      return res.payload;
    }
  };

  promise = fetchData();
</script>

{#await promise}
  <Spinner />
{:then elements}
  <table class="table table-responsive table-success">
    <thead>
      <tr>
        <td>Poste</td>
        <td>Sal.moyen</td>
        <td>Sal.mini</td>
        <td>Sal.maxi</td>
      </tr>
    </thead>
    <tbody>
      {#each Object.entries(elements) as [key, value]}
        <tr>
          <td>{value.EM_POSTE}</td>
          <td
            >{new Intl.NumberFormat("fr-FR").format(
              Math.round(value.salmoyen, 2)
            )}</td
          >
          <td
            >{new Intl.NumberFormat("fr-FR").format(
              Math.round(value.minsal, 2)
            )}</td
          >
          <td
            >{new Intl.NumberFormat("fr-FR").format(
              Math.round(value.maxsal, 2)
            )}</td
          >
        </tr>
      {/each}
    </tbody>
  </table>
  <span class="note text-secondary"
    >(1) Salaire.moyen = salaire brut hors primes</span
  >
{/await}

<style>
  .table {
    font-size: 0.65em;
  }
  .note {
    font-size: 0.4em;
    font-style: italic;
  }
</style>
